import React, {useState, useEffect} from "react";
import styles from './NavBar.module.css';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import useStore from "../../store"


const settings = ['Logout'];


function NavBar({isAuth, signUserOut}) {

  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);

  const [selectedPage, setSelectedPage] = useState('Home')

  const userData = useStore((state) => state.userData);

  const pages = isAuth ? ['Home', 'My Confessions', 'Make a Confession', 'About'] : ['Home', 'Login/Signup', 'About']

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  useEffect(() => {
    //For navBar selected tab
    let pathName = window.location.pathname
    if(pathName == '/' || pathName == '/sfu'){
      setSelectedPage('Home')
    }else if(pathName == '/myConfessions'){
      setSelectedPage('My Confessions')
    }else if(pathName == '/addConfession'){
      setSelectedPage('Make a Confession')
    }else if(pathName == '/login'){
      setSelectedPage('Login/Signup')
    }else if(pathName == '/about'){
      setSelectedPage('About')
    }
    
  }, []);


  const handleCloseNavMenu = (pageName) => {
    if(pageName === 'Home'){
      window.location.pathname = "/sfu"
    }else if(pageName === 'My Confessions'){
      window.location.pathname = "/myConfessions"
    }else if(pageName === 'Make a Confession'){
      window.location.pathname = "/addConfession"
    }else if(pageName === 'Login/Signup'){
      window.location.pathname = "/login"
    }else if(pageName === 'About'){
      window.location.pathname = "/about"
    }
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = (pageName) => {
    pageName == 'Logout' && signUserOut()
    setAnchorElUser(null);
  };

  return (
    // <div className={styles.container}>
    //     <Link className={styles.link} to="/sfu"> Home </Link>
    //     {isAuth && <Link className={styles.link} to="/myConfessions"> My Confessions </Link>}
    //     {isAuth && <Link className={styles.link} to="/addConfession"> Add a Confession </Link>}
    //     {!isAuth && <Link className={styles.link} to="/login"> Login/Signup </Link>}
    //     {isAuth && <a onClick={signUserOut} style={{cursor: 'pointer'}}>Sign Out</a>}
    // </div>

    <AppBar position="static" style={{ marginBottom: 50, background: '#CC0633'}}>
    <Container maxWidth="xl">
      <Toolbar disableGutters>
        <Typography
          variant="h6"
          noWrap
          component="div"
          sx={{ mr: 0.5, display: { xs: 'none', md: 'flex' } }}
        >
          SFU
        </Typography>
        <Typography
          variant="p"
          noWrap
          component="div"
          sx={{ mr: 2, mt: 1, display: { xs: 'none', md: 'flex' } }}
        >
          Confessions
        </Typography>

        <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
          <IconButton
            size="large"
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={handleOpenNavMenu}
            color="inherit"
          >
            <MenuIcon />
          </IconButton>
          <Menu
            id="menu-appbar"
            anchorEl={anchorElNav}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            open={Boolean(anchorElNav)}
            onClose={handleCloseNavMenu}
            sx={{
              display: { xs: 'block', md: 'none' },
            }}
          >
            {pages.map((page) => (
              <MenuItem key={page} onClick={() => handleCloseNavMenu(page)}>
                <Typography textAlign="center">{page}</Typography>
              </MenuItem>
            ))}
          </Menu>
        </Box>
        <Typography
          variant="h6"
          noWrap
          component="div"
          sx={{ mr: 2, display: { xs: 'flex', md: 'none' } }}
          //sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}
        >
          SFU
        </Typography>
        <Typography
            variant="p"
            noWrap
            component="div"
            sx={{  flexGrow: 1, display: { xs: 'flex', md: 'none' } }}
          >
          Confessions
        </Typography>
        <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
          {pages.map((page) => (
            <Button
              key={page}
              onClick={() => handleCloseNavMenu(page)}
              sx={{ my: 2, color: 'white', display: 'block', background: selectedPage == page && '#ad072e'}}
            >
              {page}
            </Button>
          ))}
        </Box>

        {isAuth && <Box sx={{ flexGrow: 0 }}>
          <Tooltip title="Open settings">
            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
              <Typography          
                variant="h6"
                sx={{ mr: 2, display: { xs: 'none', md: 'flex' } }} 
                style={{marginRight: 10, color: '#f9f9f9'}}
                >{userData && userData.displayName || 'Unknown'}
              </Typography>
              <Avatar alt="SS"/>
            </IconButton>
          </Tooltip>
          <Menu
            sx={{ mt: '45px' }}
            id="menu-appbar"
            anchorEl={anchorElUser}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={Boolean(anchorElUser)}
            onClose={handleCloseUserMenu}
          >
            {settings.map((setting) => (
              <MenuItem key={setting} onClick={() => handleCloseUserMenu(setting)}>
                <Typography textAlign="center">{setting}</Typography>
              </MenuItem>
            ))}
          </Menu>
        </Box>}
      </Toolbar>
    </Container>
  </AppBar>
  );
}

export default NavBar;
